import { createStyles, withStyles, WithStyles } from '@domonda/ui/styles';

const styles = createStyles(({ spacing, palette, typography }) => ({
  root: {
    position: 'relative',
    display: 'inline-block',
    overflow: 'hidden',
    verticalAlign: 'top',
    backgroundColor: palette.surface,
    borderRadius: '8px',
    border: '2px solid #CFDDE2',
    marginTop: '30px',
    width: '256px',
    height: '340px',
    transition: '0.4s ease all',

    '&:not(:last-child)': {
      marginRight: '30px',
    },

    '&:hover': {
      border: '2px solid #00AAE9',
    },

    '&:hover div div span': {
      display: 'block',
    },
  },
  rootSelected: {
    border: '2px solid #00AAE9',
  },
  pagesActions: {
    color: palette.secondary,
  },
  pagesActionsIconButton: {
    padding: 0,
    color: palette.secondary,
    border: 'none',
    WebkitTapHighlightColor: 'transparent',
    outline: 'none',
    margin: 0,
    cursor: 'pointer',
    backgroundColor: 'transparent',
    '-webkit-appearance': 'none',
    '-moz-appearance': 'none',
    '&:hover, &:focus': {
      color: palette.darker('secondary'),
    },
    '&:active': {
      color: palette.darkest('secondary'),
    },
    '&:disabled': {
      pointerEvents: 'none',
      opacity: 0.4,
    },
  },
  pages: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
  },
  pagesPage: {},
  details: {
    zIndex: 1,
    padding: '16px',
    position: 'absolute',
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: '#fff',
    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
  },
  detailsText: {
    color:'#4A4A4A',
    fontWeight: 'normal',
    fontSize: '12px',
    margin: 0,
  },
  authorName: {
    color: '#4A4A4A',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '19px',
    margin: '7px 0',
  },
  detailsInvoiceDots: {
    color: palette.darker('textLight'),
    fontSize: typography.subheading.fontSize,
    lineHeight: 0.5,
    '& > span': {
      display: 'inline-block',
      '&:not(:last-child)': {
        marginRight: spacing(0.2),
      },
    },
  },
  detailsInvoiceDotsSelected: {
    color: palette.secondary,
  },
  checkBoxWrapper: {
    display: 'none',
    width: '16px',
    height: '16px',
    borderRadius: '4px',
    background: '#FFFFFF',
    position: 'absolute',
    top: '12px',
    right: '12px',
    border: '1px solid #4A4A4A',
  },
  checkBox: {
    display: 'none',

    '& svg': {
      width: '100%',
      height: '100%',
      padding: '1px',
    },

    '& rect': {
      fill: '#FFFFFF',
    }
  },
  checkBoxSelected: {
    display: 'block',
    background: '#00AAE9',
    border: '1px solid #00AAE9',

    '& span': {
      display: 'block',
    },
  },
}));

export type Decorate = WithStyles<typeof styles>;

export const decorate = withStyles(styles);
